import { Box, Typography } from '@mui/material'
import traffic_highway from 'src/assets/traffic_simulation_highway.jpeg'
import traffic_overlay from 'src/assets/traffic_simulation_overlay.png'
import traffic_safety from 'src/assets/traffic_simulation_safety.jpeg'
import traffic_smart_city from 'src/assets/traffic_simulation_smart_city.jpeg'
import GISSolutionsCard from 'src/components/GISSolutions/GISSolutionsCard'
import { trafficSimulations } from 'src/components/TrafficSimulation/enums'

const TrafficSimulation = () => {
  return (
    <Box>
      {/* Hero */}
      <Box
        sx={{
          height: { xs: 'fit-content', md: '350px' },
          backgroundImage: `url(${traffic_highway})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundBlendMode: 'overlay',
          backgroundColor: '#2a3a4aaa',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 8, md: 0 },
        }}
      >
        <Typography
          variant="h3"
          fontWeight={700}
          fontStyle="italic"
          color="#f4f4f4"
          textAlign="center"
          sx={{ width: { xs: '80%', md: '700px' } }}
        >
          Traffic Simulation
        </Typography>
        <Typography
          variant="h6"
          color="#e0e0e0"
          textAlign="center"
          sx={{ mt: 2, width: { xs: '80%', md: '600px' } }}
        >
          Modeling, analysis, and optimization of road networks and urban mobility
        </Typography>
      </Box>

      {/* Capability cards */}
      <Box sx={{ py: 6 }}>
        <Typography
          variant="h5"
          fontWeight="500"
          sx={{
            mb: 5,
            textAlign: 'center',
            borderBottom: '2px solid #000',
            width: 'fit-content',
            mx: 'auto',
          }}
        >
          Our Capabilities
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
          {trafficSimulations.map((simulation, index) => (
            <GISSolutionsCard {...simulation} key={index} />
          ))}
        </Box>
      </Box>

      {/* Feature: Smart City */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'stretch',
          minHeight: '320px',
        }}
      >
        <Box
          sx={{
            flex: 1,
            backgroundImage: `url(${traffic_smart_city})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: { xs: '240px', md: 'unset' },
          }}
        />
        <Box
          sx={{
            flex: 1,
            backgroundColor: '#1e2d3d',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 4, md: 7 },
            py: { xs: 5, md: 6 },
          }}
        >
          <Typography variant="h5" fontWeight={600} color="#f4f4f4" gutterBottom>
            Smart City Integration
          </Typography>
          <Typography color="#c8d6e0" sx={{ fontSize: '16px', lineHeight: 1.8 }}>
            We connect traffic simulation models with smart city platforms, enabling real-time data exchange between sensors, signal controllers, and urban management systems. Our solutions support connected and autonomous vehicle (CAV) environments and IoT-based infrastructure.
          </Typography>
        </Box>
      </Box>

      {/* Feature: Simulation Tools */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row-reverse' },
          alignItems: 'stretch',
          minHeight: '320px',
        }}
      >
        <Box
          sx={{
            flex: 1,
            backgroundImage: `url(${traffic_overlay})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: { xs: '240px', md: 'unset' },
          }}
        />
        <Box
          sx={{
            flex: 1,
            backgroundColor: '#f5f7fa',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 4, md: 7 },
            py: { xs: 5, md: 6 },
          }}
        >
          <Typography variant="h5" fontWeight={600} color="#1e2d3d" gutterBottom>
            Advanced Simulation Tools
          </Typography>
          <Typography color="#445566" sx={{ fontSize: '16px', lineHeight: 1.8 }}>
            Using industry-leading platforms such as PTV VISSIM, we build and calibrate detailed simulation models of intersections, corridors, and full urban networks. Vehicle movements, signal phases, and lane assignments are visualized and analyzed to support informed design decisions.
          </Typography>
        </Box>
      </Box>

      {/* Feature: Safety */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'stretch',
          minHeight: '320px',
        }}
      >
        <Box
          sx={{
            flex: 1,
            backgroundImage: `url(${traffic_safety})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: { xs: '240px', md: 'unset' },
          }}
        />
        <Box
          sx={{
            flex: 1,
            backgroundColor: '#1e2d3d',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            px: { xs: 4, md: 7 },
            py: { xs: 5, md: 6 },
          }}
        >
          <Typography variant="h5" fontWeight={600} color="#f4f4f4" gutterBottom>
            Road Safety & Compliance
          </Typography>
          <Typography color="#c8d6e0" sx={{ fontSize: '16px', lineHeight: 1.8 }}>
            Safety is at the core of every project. We conduct conflict analysis, pedestrian safety assessments, and road audit simulations to identify hazards before they occur. Our deliverables meet national and EU road safety standards and support Vision Zero goals.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default TrafficSimulation
